import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker'
import dayjs from 'dayjs'
import React from 'react'

const DateInput2 = ({ date, setDate }) => {
    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div style={{ width: '100%' }}> {/* Ensures full width */}
                    <MobileDateTimePicker
                        id="newDate"
                        value={dayjs(date)}
                        format="DD/MM/YYYY hh:mm A"
                        onChange={(date) => setDate(date?.format('YYYY-MM-DD HH:mm:ss'))}
                        ampm={true}
                        slotProps={{ textField: { fullWidth: true } }} // Ensures full width
                    />
                </div>
            </LocalizationProvider>
        </>
    )
}

export default DateInput2